import { createApp } from 'vue';
import WmaToMp3Converter from '@/Components/WmaToMp3Converter.vue';
import '@styles/app.css';

createApp(WmaToMp3Converter).mount('#wma-to-mp3-converter');
